import { Stack, Typography } from '@mui/material';
import React from 'react';
import { ModalProps, useModal } from '../../../../hooks/useDialog';
import useLocalization from '../../../../hooks/useLocalization';
import { useGetAgentBalance } from '../../../../queries';
import StyledDetailsRow from '../atoms/StyledDetailsRow';
import { StyleObj } from '../../../../@types';
import BalanceAdjustmentForm from '../organisms/BalanceAdjustmentForm';
const MODAL_PROPS: ModalProps = {
  maxWidth: 'sm' as const,
  fullWidth: true,
  slotProps: {
    paper: {
      sx: {
        backgroundColor: 'neutral.700',
        margin: '20px',
        border: '1px solid',
        borderColor: 'neutral.100',
        borderRadius: '10px',
      },
    },
  },
};
const formatBalance = (balance: number, currency: string) => {
  return Intl.NumberFormat('en-US', { style: 'currency', currency }).format(balance);
};
const styles: StyleObj = {
  container: {
    m: '10px',
    border: '1px solid',
    borderColor: 'neutral.25',
    borderRadius: '10px',
    backgroundColor: 'neutral.600',
    flexGrow: 1,
  },
};
const AgentBalance = ({ userId }: { userId: string }) => {
  const { t } = useLocalization();
  const { data: agentBalance, refetch } = useGetAgentBalance({ userId });
  const mainBalance = agentBalance?.main;
  const balance = formatBalance(mainBalance?.balance || 0, mainBalance?.currency || 'EUR');
  const { openModal } = useModal();
  const handleClick = () => {
    mainBalance &&
      openModal(<BalanceAdjustmentForm userBalanceData={mainBalance} handleUpdate={refetch} />, MODAL_PROPS);
  };

  return (
    <Stack
      direction='row'
      spacing={1}
      sx={{
        alignItems: 'center',
        margin: 'auto',
        maxWidth: '600px',
        width: '100%',
        justifyContent: 'space-between',
        padding: 2,
      }}
    >
      <StyledDetailsRow label={t('balanceEUR')} value={balance} onRowClick={handleClick} sx={styles.container} />
      <Typography sx={{ color: 'neutral.300', fontSize: 13 }}>{t('currentBalance')}</Typography>
    </Stack>
  );
};

export default AgentBalance;
